import { UnitedStatesOperationCost } from '..'

export const IllinoisOperationCost = {
  ...UnitedStatesOperationCost,
} as const
